import { supabase } from "@/integrations/supabase/client";

/**
 * Convert a relative storage path to a full public URL.
 * Returns null if no path provided.
 * Appends cache-bust param to force fresh loads after uploads.
 */
export function getLogoUrl(path?: string | null): string | null {
  if (!path) return null;

  // If it's already a full URL, return as-is
  if (path.startsWith("http")) return path;

  // Strip accidental bucket prefix
  const cleanPath = path.replace(/^org-assets\//, "");

  const { data } = supabase.storage.from("org-assets").getPublicUrl(cleanPath);

  return data.publicUrl;
}
